import { render, staticRenderFns } from "./WorkspaceNavigation.vue?vue&type=template&id=e302f120&scoped=true"
import script from "./WorkspaceNavigation.vue?vue&type=script&lang=ts"
export * from "./WorkspaceNavigation.vue?vue&type=script&lang=ts"
import style0 from "./WorkspaceNavigation.vue?vue&type=style&index=0&id=e302f120&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e302f120",
  null
  
)

export default component.exports